module.exports = __webpack_public_path__ + "media/images/synaptiq-logo-aefb27a8.svg";